import React from 'react';
import { ArrowRight, Play, Download } from 'lucide-react';
import './Hero.css';

function Hero({ onPlaquetteClick, onContactClick }) {

  return (
    <section className="hero">
      <div className="hero__background">
        <div className="hero__gradient" />
        <div className="hero__pattern" />
      </div>
      
      <div className="hero__container container">
        <div className="hero__content">
          <span className="hero__badge">
            Logiciel breveté INPI
          </span>
          
          <h1 className="hero__title">
            <span className="hero__title-black">Procu</span><span className="hero__title-accent">Matcher</span>
            <br />
            <span className="hero__title-sub">Une interface simple et intuitive</span>
          </h1>
          
          <p className="hero__description">
            Faites matcher automatiquement mandants et mandataires. 
            ProcuMatcher remplit automatiquement les formulaires CERFA 
            et gère le suivi avec vos électeurs, sans aucune intervention de votre part.
          </p>
          
          <div className="hero__highlight">
            <strong>Nous travaillons en exclusivité :</strong> soyez le premier sur votre territoire à installer l'outil !
          </div>
          
          <div className="hero__actions">
            <button onClick={onContactClick} className="hero__btn hero__btn--primary">
              Obtenir ProcuMatcher
              <ArrowRight size={18} />
            </button>
            <a href="https://demo.procumatcher.fr" className="hero__btn hero__btn--secondary" target="_blank" rel="noopener noreferrer">
              <Play size={18} />
              Tester la démo
            </a>
          </div>
          
          <button onClick={onPlaquetteClick} className="hero__download">
            <Download size={16} />
            Télécharger la plaquette explicative
          </button>
        </div>
        
        <div className="hero__visual">
          <div className="hero__image-wrapper">
            {/* Vidéo en autoplay (remplace l'image statique) */}
            <video 
              className="hero__video"
              autoPlay 
              loop 
              muted 
              playsInline
              poster="/images/hero-image.jpg"
            >
              <source src="/videos/demo-procumatcher.mp4" type="video/mp4" />
              {/* Fallback image si vidéo non supportée */}
              <img 
                src="/images/hero-image.jpg" 
                alt="Interface ProcuMatcher" 
                className="hero__image"
              />
            </video>
            <div className="hero__image-overlay" />
          </div>
          
          <div className="hero__floating-card hero__floating-card--1">
            <div className="hero__card-icon">✓</div>
            <div className="hero__card-text">
              <strong>300+</strong>
              <span>Campagnes</span>
            </div>
          </div>
          
          <div className="hero__floating-card hero__floating-card--2">
            <div className="hero__card-icon">📄</div>
            <div className="hero__card-text">
              <strong>CERFA</strong>
              <span>Auto-rempli</span>
            </div>
          </div>
        </div>
      </div>
      
      <div className="hero__scroll-indicator">
        <div className="hero__scroll-mouse">
          <div className="hero__scroll-wheel" />
        </div>
      </div>
    </section>
  );
}

export default Hero;
